import React from "react";

/**
 * CatalogDropdown
 * Usage: <CatalogDropdown catalogName="AcademicYear" onChange={...} />
 */
  const CatalogOptions = ({name, value, catalogName, onChange,className}) => {
  // read cached catalogs from sessionStorage
  const catalogs = JSON.parse(sessionStorage.getItem("cacheCatalogs") || "[]");

  // find the catalog by name
  const catalog = catalogs.find(c => c.catalogName === catalogName);

  if (!catalog) {
    return <div>No catalog found for {catalogName}</div>;
  }

  return (
    <div className="catalog-dropdown">
        <select
          value={value || ""}
          onChange={e => onChange?.(name,e.target.value)}
          className={className}
        >
         {catalog.entries.length>0?( catalog.entries
          //.filter(entry => entry.active) // only active entries
          .map(entry => (
            <option key={entry.id} value={entry.code}>
              {entry.name}
            </option>
          ))):[]
        }
        </select>
     
    </div>
  );
};

export default CatalogOptions;